<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data () {
    return {
      tokenTimer: null
    };
  },
  created () {
    this.getToken();
    // 10min一刷token
    const timer = 10 * 60 * 1000;
    this.tokenTimer = setInterval(() => {
      this.getToken();
    }, timer);
  },
  methods: {
    // 获取token
    getToken () {
      this.$http.getToken();
    }
  },
  beforeDestroy () {
    clearInterval(this.tokenTimer);
  },
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
</style>
